/* eslint-disable no-use-before-define */
import React from 'react';

export const navigationAgents = [
        { name: 'Support', dataQa: 'support', href: '/support', icon: <img alt='support' src='/assets/navigation-icons/support.svg' />, iconActive: <img alt='support-active' src='/assets/navigation-icons/support-black.svg' />, enabled: true },
        { name: 'Get Started', dataQa: 'get-started', href: '/get-started', icon: <img alt='support' src='/assets/navigation-icons/support.svg' />, iconActive: <img alt='support-active' src='/assets/navigation-icons/support-black.svg' />, enabled: true },
];

export const extraNavigation = [
    {
        name: 'Leo',
        dataQa: 'leo',
        href: '/dashboard/leo/widget-customisation',
        icon: <img alt='agent-1' src='/assets/agents/leo-agent.svg' />,
        iconActive: <img alt='agent-1-active' src='/assets/agents/leo-agent.svg' />,
        enabled: true,
    },
    {
        name: 'Claire',
        dataQa: 'claire',
        href: '/dashboard/claire/widget-customisation',
        icon: <img alt='agent-2' src='/assets/agents/claire-agent-icon.svg' />,
        iconActive: <img alt='agent-2-active' src='/assets/agents/claire-agent-icon.svg' />,
        enabled: true,
    },
    // {
    //     name: 'Agent Description',
    //     dataQa: 'agent-3',
    //     href: '/insights?agentId=agent-3',
    //     icon: <img alt='agent-3' src='/assets/agents/claire-agent-icon.svg' />,
    //     iconActive: <img alt='agent-3-active' src='/assets/agents/claire-agent-icon.svg' />,
    //     enabled: true,
    // },
];
